<template>
  <div class="gpsr-template-edit">
    <Spin v-if="pageLoading" fix></Spin>
    <div class="item-warning" v-if="warTips">{{ warTips }}</div>
    <Form
      ref="modalFormRef"
      :model="modalFormData"
      :rules="modalFormRules"
      :label-width="100"
      class="mt10 modal-form-template"
      v-if="!$common.isEmpty(templateKey)"
    >
      <div class="form-top">
        <FormItem label="名称:" prop="itemName" :label-width="120">
          <dytInput v-model="modalFormData.itemName" placeholder="请输入名称" />
        </FormItem>
        <FormItem label="可用事业部:" prop="businessDeptId" :label-width="120">
          <dyt-select v-model="modalFormData.businessDeptId" placeholder="请选择可用事业部">
            <Option v-for="(item, oIndex) in businessDeptInfo" :value="item.id" :key="`${item.id}-${oIndex}`" :label="item.name" />
          </dyt-select>
        </FormItem>
      </div>
      <div class="form-block" v-if="!['safetyCertificate'].includes(templateKey)">
        <FormItem label="Manufacturer:" prop="manufacturer" v-if="['manufacturer'].includes(templateKey)">
          <dytInput v-model="modalFormData.manufacturer" placeholder="请输入Manufacturer" />
        </FormItem>
        <FormItem label="Name:" prop="name" v-if="['euCompany', 'ukCompany'].includes(templateKey)">
          <dytInput v-model="modalFormData.name" placeholder="请输入Name" />
        </FormItem>
        <FormItem label="Address:" prop="address" v-if="['manufacturer', 'euCompany', 'ukCompany'].includes(templateKey)">
          <dytInput v-model="modalFormData.address" placeholder="请输入Address" />
        </FormItem>
        <FormItem label="e-mail:" prop="eMail" v-if="['manufacturer', 'euCompany', 'ukCompany'].includes(templateKey)">
          <dytInput v-model="modalFormData.eMail" placeholder="请输入e-mail" />
        </FormItem>
        <FormItem label="WARNING:" prop="warning" v-if="['warning'].includes(templateKey)">
          <dytInput
            type="textarea"
            v-model="modalFormData.warning"
            :autosize="{minRows: 6, maxRows: 8}"
            :show-word-limit="true"
            placeholder="请输入WARNING，多个语言请一起填写，请注意字数"
          />
        </FormItem>
      </div>
      <FormItem label="安全/环保/认证标识:" prop="identificationType" v-if="['safetyCertificate'].includes(templateKey)" :label-width="140">
        <CheckboxGroup v-model="modalFormData.identificationType" class="type-check-content">
          <Checkbox v-for="(item, index) in iconDataList" :label="item.identificationType" :key="`${item.identificationType}-${index}`">
            <div class="type-check-item">
              <div class="type-check-label">{{ item.name }}</div>
              <img class="mt5" :src="item.path" :alt="item.name" :title="item.name">
            </div>
          </Checkbox>
        </CheckboxGroup>
      </FormItem>
    </Form>
  </div>
</template>
<script>

const matchingKey = {
  manufacturer: {
    itemName: 'name',
    itemId: 'manufacturerInfoId',
    manufacturer: 'manufacturer',
    businessDeptId: 'businessDeptId',
    address: 'address',
    eMail: 'eMail',
  },
  euCompany: {
    itemName: 'europeAgentName',
    itemId: 'europeAgentInfoId',
    name: 'name',
    businessDeptId: 'businessDeptId',
    address: 'address',
    eMail: 'eMail',
  },
  ukCompany: {
    itemName: 'britainAgentName',
    itemId: 'britainAgentInfoId',
    name: 'name',
    businessDeptId: 'businessDeptId',
    address: 'address',
    eMail: 'eMail',
  },
  warning: {
    itemName: 'name',
    itemId: 'securityWarningInfoId',
    businessDeptId: 'businessDeptId',
    warning: 'warning',
  },
  safetyCertificate: {
    itemName: 'name',
    itemId: 'identificationInfoId',
    businessDeptId: 'businessDeptId',
    identificationType: 'identificationType',
  }
}

export default {
  name: "gpsrTemplateEdit",
  components: {},
  props: {
    moduleData: {
      type: Object,
      default: () => {
        return {}
      }
    }
  },
  data() {
    return {
      pageLoading: true,
      modalFormData: {
        name: '',
        itemName: '',
        businessDeptId: null,
        manufacturer: '',
        address: '',
        eMail: '',
        warning: '',
        identificationType: [],
        itemId: null
      },
      modalFormRules: {
        itemName: [
          { required: true, validator: this.$common.strMaxVerify, maxLength: 50, trigger: 'blur', msg: '请输入名称' },
          { required: true, validator: this.$common.strMaxVerify, maxLength: 50, trigger: 'change', msg: '请输入名称' }
        ],
        businessDeptId: [
          { required: true, validator: this.$common.formItemVerify, trigger: 'change', msg: '请选择可用事业部' }
        ],
        manufacturer: [
          { required: true, validator: this.$common.strMaxVerify, maxLength: 200, trigger: 'blur', msg: '请输入Manufacturer' },
          { required: true, validator: this.$common.strMaxVerify, maxLength: 200, trigger: 'change', msg: '请输入Manufacturer' }
        ],
        address: [
          { required: true, validator: this.$common.strMaxVerify, maxLength: 200, trigger: 'blur', msg: '请输入Address' },
          { required: true, validator: this.$common.strMaxVerify, maxLength: 200, trigger: 'change', msg: '请输入Address' }
        ],
        eMail: [
          { required: true, validator: this.$common.verifyEmail, trigger: 'blur', msg: '请输入e-mail' },
          { required: true, validator: this.$common.verifyEmail, trigger: 'change', msg: '请输入e-mail' }
        ],
        name: [
          { required: true, validator: this.$common.strMaxVerify, maxLength: 200, trigger: 'blur', msg: '请输入Name' },
          { required: true, validator: this.$common.strMaxVerify, maxLength: 200, trigger: 'change', msg: '请输入Name' }
        ],
        warning: [
          { required: true, validator: this.$common.strMaxVerify, maxLength: 500, trigger: 'blur', msg: '请输入WARNING' },
          { required: true, validator: this.$common.strMaxVerify, maxLength: 500, trigger: 'change', msg: '请输入WARNING' }
        ],
        identificationType: [
          { required: true, validator: this.$common.formItemVerify, trigger: 'change', msg: '请选择安全/环保/认证标识' }
        ],
      },
    };
  },
  watch: {},
  computed: {
    // 获取所有事业部
    allBusinessDept() {
      return this.$store.getters.getBusinessDeptList || [];
    },
    // 可查看(有权限)的事业部ID
    businessDeptIdList () {
      if (!this.$store.getters['authUserInfo'] || !this.$store.getters['authUserInfo'].securityUser) return [];
      if (this.$common.isEmpty(this.$store.getters['authUserInfo'].securityUser.businessDeptIds)) return [];
      return this.$store.getters['authUserInfo'].securityUser.businessDeptIds.split(',');
    },
    // 可查看(有权限)的事业部信息
    businessDeptInfo () {
      if (this.$common.isEmpty(this.allBusinessDept) || this.$common.isEmpty(this.businessDeptIdList)) return [];
      const filterList = this.allBusinessDept.filter(item => this.businessDeptIdList.includes((item.id).toString()));
      return filterList;
    },
    templateKey () {
      if (this.$common.isEmpty(this.moduleData) || this.$common.isEmpty(this.moduleData.key)) return '';
      return this.moduleData.key;
    },
    parentRes () {
      if (this.$common.isEmpty(this.moduleData) || this.$common.isEmpty(this.moduleData.row)) return {};
      return this.moduleData.row;
    },
    warTips () {
      if (this.$common.isEmpty(this.moduleData) || this.$common.isEmpty(this.moduleData.warTips)) return '';
      return this.moduleData.warTips;
    },
    // 标识图片
    iconDataList () {
      if (this.$common.isEmpty(this.moduleData) || this.$common.isEmpty(this.moduleData.iconDataList)) return [];
      return this.moduleData.iconDataList;
    },
  },
  created() {
    this.pageLoading = true;
  },
  mounted () {
    this.initPage().finally(() => {
      this.pageLoading = false;
    });
  },
  methods: {
    // 初始化数据
    initPage () {
      return new Promise((resolve) => {
        let awaitRes = [this.getDetails];
        this.$common.promiseAll(awaitRes).finally(() => {
          if (!this.businessDeptIdList.includes((this.modalFormData.businessDeptId || '').toString())) {
            this.modalFormData.businessDeptId = null;
          }
          resolve({ state: 'end' });
        });
      })
    },
    // 详情
    getDetails () {
      return new Promise((resolve) => {
        if (!this.$common.isEmpty(this.parentRes)) {
          Object.keys(matchingKey[this.templateKey]).forEach(key => {
            if (key == 'identificationType') {
              if (!this.$common.isEmpty(this.parentRes[matchingKey[this.templateKey][key]])) {
                this.modalFormData[key] = this.parentRes[matchingKey[this.templateKey][key]].split(',');
              }
            } else {
              this.modalFormData[key] = this.parentRes[matchingKey[this.templateKey][key]];
            }
          });
        }
        resolve({ state: 'end' });
      })
    },
    // 保存表单数据
    saveFormData (obj) {
      return new Promise((resolve) => {
        this.$refs.modalFormRef.validate((valid) => {
          if (!valid) {
            this.$common.inputFocus('modal-form-template');
            return resolve({ valid: false, state: 'fail' })
          };
          let backRes = {};
          Object.keys(matchingKey[this.templateKey]).forEach(key => {
            if (key == 'identificationType') {
              backRes[matchingKey[this.templateKey][key]] = this.modalFormData[key].join(',');
            } else {
              backRes[matchingKey[this.templateKey][key]] = this.modalFormData[key];
            }
          });
          this.pageLoading = true;
          this.axios[this.$common.isEmpty(this.modalFormData.itemId) ? 'post' : 'put'](obj.saveApi, backRes).then(res => {
            this.pageLoading = false;
            if (res && res.data && res.data.code == 0) {
              resolve({ valid: true, state: 'success' });
            } else {
              resolve({ valid: true, state: 'fail' });
            }
          }).catch(() => {
            this.pageLoading = false;
            resolve({ valid: true, state: 'fail' });
          })
        })
      })
    }
  }
};
</script>
<style lang="less" scoped>
.gpsr-template-edit {
  position: relative;
  text-align: center;
  .item-warning {
    display: inline-block;
    padding: 5px 15px;
    border-radius: 5px;
    color: #fff;
    background: #ff9b00;
  }
  .form-block{
    padding-top: 20px;
    border: 1px solid #ccc;
  }
  :deep(.ivu-form){
    padding: 0 15px;
    .ivu-form-item-label{
      padding-right: 5px;
    }
    .ivu-form-item {
      margin-left: 10px;
      margin-right: 20px;
    }
  }
  :deep(.form-top){
    display: inline-block;
    text-align: center;
    padding-right: 40px;
    .ivu-form-item {
      width: 560px;
    }
  }
  :deep(.type-check-content) {
    position: relative;
    margin-top: 12px;
    padding: 15px 15px 5px 15px;
    text-align: left;
    border: 1px solid #ccc;
    .ivu-checkbox-wrapper{
      display: inline-block;
      margin-right: 10px;
      margin-bottom: 10px;
      padding: 10px;
      border: 1px solid #ccc;
      border-radius: 5px;
    }
    .ivu-checkbox{
      vertical-align: top;
    }
    .type-check-item{
      position: relative;
      display: inline-block;
      text-align: left;
      vertical-align: top;
      .type-check-label{
        line-height: initial;
      }
      img {
        display: block;
        padding: 0px;
        max-height: 70px;
        object-fit: contain;
      }
    }
  }
}
</style>
